export const env = {
  uid: "0", // 用户 uid, 用于日志上下文或登录校验
};

/** 游戏 ID，来源于 crawler/wiki/manifest.json */
export const GAME_ID = 3203;

/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const TOOL_ID = "h20tdvck";

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType */
export const TOOL_TYPE = 1;
